export const CONTROL_PANEL_TRANSLATIONS = {
  es: {
    confirmDeleteEvent: '¿Eliminar evento?',
    eventDeleted: 'Evento eliminado',
    accessRestricted: 'Acceso restringido',
    loadingPermissions: 'Cargando permisos...',
    noPermissionsConfigured: 'Sin permisos configurados',
    noPermissionsDescription:
      'Tu rol no tiene permisos asignados o no existe en esta base de datos. Pide al administrador que cree el rol y te lo asigne de nuevo.',
    retry: 'Reintentar',
    staffAccessAs: 'Acceso como',
    staffViewLimited: 'Vista limitada a tus permisos',
    sectionLabel: 'Sección',
    groups: {
      shop: 'TIENDA',
      reservations: 'RESERVAS',
      eventsTcg: 'EVENTOS & TCG',
      community: 'COMUNIDAD',
      settings: 'CONFIGURACION',
    },
    tabs: {
      dashboard: 'Dashboard',
      products: 'Productos',
      orders: 'Pedidos',
      reservations: 'Reservas Prod.',
      stockAlerts: 'Avisame',
      tables: 'Gestion Mesas',
      gameRes: 'Juegos',
      tableRes: 'Mesas',
      events: 'Eventos/Torneos',
      boosters: 'Boosters/Sets',
      cardSync: 'Sync Cartas',
      loyalty: 'Fidelidad',
      users: 'Usuarios',
      collections: 'Colecciones',
      billing: 'Facturacion',
      roles: 'Roles',
      settings: 'Ajustes',
    },
  },
  en: {
    confirmDeleteEvent: 'Delete event?',
    eventDeleted: 'Event deleted',
    accessRestricted: 'Access restricted',
    loadingPermissions: 'Loading permissions...',
    noPermissionsConfigured: 'No permissions configured',
    noPermissionsDescription:
      'Your role has no permissions assigned or does not exist in this database. Ask the admin to create the role and reassign it.',
    retry: 'Retry',
    staffAccessAs: 'Accessing as',
    staffViewLimited: 'View limited to your permissions',
    sectionLabel: 'Section',
    groups: {
      shop: 'SHOP',
      reservations: 'RESERVATIONS',
      eventsTcg: 'EVENTS & TCG',
      community: 'COMMUNITY',
      settings: 'SETTINGS',
    },
    tabs: {
      dashboard: 'Dashboard',
      products: 'Products',
      orders: 'Orders',
      reservations: 'Prod. Reserv.',
      stockAlerts: 'Notify Me',
      tables: 'Table Config',
      gameRes: 'Games',
      tableRes: 'Tables',
      events: 'Events/Tournaments',
      boosters: 'Boosters/Sets',
      cardSync: 'Card Sync',
      loyalty: 'Loyalty',
      users: 'Users',
      collections: 'Collections',
      billing: 'Billing',
      roles: 'Roles',
      settings: 'Settings',
    },
  },
};

